import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import auth from '@/store/modules/auth.module'
import global from '@/store/modules/global.module'
import events from '@/store/modules/events.module'
import errors from './modules/errors.module'
import profiles from './modules/profiles.module'
import invitations from './modules/invitations.module'
import comments from './modules/comments.module'
import items from './modules/items.module'
import documents from './modules/documents.module'
import notifications from './modules/notifications.module'



Vue.use(Vuex);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  modules: {
    auth,
    global,
    errors,
    events,
    profiles,
    invitations,
    comments,
    items,
    documents,
    notifications
  },
  plugins: [createPersistedState(
    {
      storage: window.sessionStorage,
    }
  )]
});
